import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

export const useWorkflowDetailsHeaderStyles = makeStyles<Theme, { bgColor: string }>((theme) => ({
  root: {
    borderRadius: '8px',
    padding: '0.5rem 1rem 0.5rem 1rem',
    backgroundColor({ bgColor }) {
      return bgColor;
    }
  },
  table: {
    tableLayout: 'fixed',
    color: 'white',
    width: '100%'
  },
  label: {
    fontSize: '13px',
    color: 'white',
    textTransform: 'uppercase'
  },
  archived: {
    color: Colors.cancelledDeletedRed
  },
  iconCol: {
    width: '50px'
  },
  orderNumberColDiv: {
    overflow: 'hidden',
    width: '100%',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      color: 'black'
    },
    paddingRight: 0
  },
  orderNumberText: {
    marginBottom: 0,
    paddingRight: 0,
    textOverflow: 'ellipsis'
  },
  mobileOrderStatusText: {
    marginLeft: '1em',
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    color: 'black',
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  orderStatusCol: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    textAlign: 'right',
    fontSize: '17px',
    fontWeight: 500,
    textTransform: 'uppercase',
    padding: '0 1em'
  },
  actionButtonCol: {
    width: '100px',
    textAlign: 'right'
  }
}));
